/* global axios */
import ApiClient from '../ApiClient';

class OnixFlowInboxesAPI extends ApiClient {
  constructor() {
    super('onix/flows', { accountScoped: true });
  }

  get(flowId) {
    return axios.get(`${this.url}/${flowId}/flow_inboxes`);
  }

  create(flowId, data) {
    return axios.post(`${this.url}/${flowId}/flow_inboxes`, data);
  }

  update(flowId, inboxId, data) {
    return axios.patch(`${this.url}/${flowId}/flow_inboxes/${inboxId}`, data);
  }

  delete(flowId, inboxId) {
    return axios.delete(`${this.url}/${flowId}/flow_inboxes/${inboxId}`);
  }
}

export default new OnixFlowInboxesAPI();
